"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileDropzone = FileDropzone;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const FileDropzone_style_1 = require("./FileDropzone.style");
function FileDropzone({ onDrop, children }) {
    const [isDraggingOverBody, setIsDraggingOverBody] = react_1.default.useState(false);
    // This counter is used to accurately detect when user is hovering over body.
    // Otherwise dragleave event is fired when cursor leave any child element. This behaviour is causing dropzone to flicker
    // Details: https://stackoverflow.com/questions/7110353/html5-dragleave-fired-when-hovering-a-child-element
    const dragEnterLeaveCounter = react_1.default.useRef(0);
    const handleDropOnDropzone = (event) => {
        event.preventDefault();
        onDrop(Array.from(event.dataTransfer.files));
        setIsDraggingOverBody(false);
    };
    react_1.default.useEffect(() => {
        // This function must be called on dragover event.
        // Otherwise drop event wont be triggered: Probably bug.
        // Details: https://stackoverflow.com/questions/21339924/drop-event-not-firing-in-chrome
        const handleDragoverBody = (event) => {
            event.preventDefault();
        };
        const handleDragEnterBody = () => {
            setIsDraggingOverBody(true);
            dragEnterLeaveCounter.current += 1;
        };
        const handleDragleaveBody = () => {
            dragEnterLeaveCounter.current -= 1;
            if (dragEnterLeaveCounter.current === 0) {
                setIsDraggingOverBody(false);
            }
        };
        const handleDropBodyOnBody = () => {
            setIsDraggingOverBody(false);
        };
        document.body.addEventListener('dragover', handleDragoverBody);
        document.body.addEventListener('dragenter', handleDragEnterBody);
        document.body.addEventListener('dragleave', handleDragleaveBody);
        document.body.addEventListener('drop', handleDropBodyOnBody);
        return () => {
            document.body.removeEventListener('dragover', handleDragoverBody);
            document.body.removeEventListener('dragenter', handleDragEnterBody);
            document.body.removeEventListener('dragleave', handleDragleaveBody);
            document.body.removeEventListener('drop', handleDropBodyOnBody);
        };
    }, []);
    return (
    // @ts-ignore
    (0, jsx_runtime_1.jsxs)(FileDropzone_style_1.DropzoneContainer, { onDrop: handleDropOnDropzone, children: [(0, jsx_runtime_1.jsxs)(FileDropzone_style_1.DropzoneOverlay, { isDraggingOverBody: isDraggingOverBody, children: [(0, jsx_runtime_1.jsx)(FileDropzone_style_1.DropzoneOverlayText, { children: "Nahra\u0165 s\u00FAbory" }), (0, jsx_runtime_1.jsx)(FileDropzone_style_1.StyledCloudUpload, {})] }), (0, jsx_runtime_1.jsx)(FileDropzone_style_1.DropzoneContent, { isDraggingOverBody: isDraggingOverBody, children: children })] }));
}
